import { render, staticRenderFns } from "./exportDetalleLibrosObsequios.vue?vue&type=template&id=75a78c2e&scoped=true"
import script from "./exportDetalleLibrosObsequios.vue?vue&type=script&lang=js"
export * from "./exportDetalleLibrosObsequios.vue?vue&type=script&lang=js"
import style0 from "./exportDetalleLibrosObsequios.vue?vue&type=style&index=0&id=75a78c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a78c2e",
  null
  
)

export default component.exports